import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { UtilityService } from 'src/app/core/shared/utility.service';
import { FilterRequestEvaluated } from './filter-request-evaluated.model';
import { Observable } from 'rxjs';
import { ResposeGeneric } from 'src/app/core/shared/respose-generic';
import { environment } from 'src/environments/environment';
import { DeclineAssigment } from '../../assessments/shared/decline-assigment.model';
import { FilterRequestTest } from './filter-request-test.model';
import { ReturnRecognition } from './returnRecognition.model';
import { FilterRequestRecon } from './filter-request-recon.model';

@Injectable()
export class ReportsService {
  uriRequestTest = environment.urlServices + 'solicitudes/pruebas/reportes';
  uriRequestEvaluated = environment.urlServices + 'solicitudesEvaluadas';
  uriReturnRecognition = this.uriRequestEvaluated + '/devolverReconocimiento';
  uriRequest = environment.urlServices + 'solicitudes';
  uriRequestStudent = this.uriRequest + '/verSolicitudes';
  uriDeclineRequest = this.uriRequest + '/declinarSolicitud';
  uriStateRequests = this.uriRequest +  '/estadoSolicitudes';
  uriStateTesting = this.uriRequest + '/estadoPruebas';
  uriRequestRecog = this.uriRequest + '/reconocimientos';
  uriValRequestsPifle = this.uriRequest + '/valSolicitudesPrueba';
  uriTestStudent = this.uriRequest + '/pruebasEstudiante';
  uriDeclineTests = this.uriRequest + '/declinarPruebas';
  uriNotesRequests = this.uriRequest + '/verObservaciones';

  constructor(private httpClient: HttpClient, private utilityService: UtilityService) { }

  getRequestEvaluated(requestFilter: FilterRequestEvaluated ): Observable<ResposeGeneric> {
    return this.httpClient.get<ResposeGeneric>(this.utilityService.addQueryParam(this.uriRequestEvaluated, requestFilter));
  }

  returnRecognition(returnRecognition: ReturnRecognition): Observable<ResposeGeneric> {
    return this.httpClient.post<ResposeGeneric>(this.uriReturnRecognition, returnRecognition);
  }

  getRequestsStudent(cedula: String): Observable<ResposeGeneric> {
    const parameters = { cedula : cedula };
    return this.httpClient.get<ResposeGeneric>(this.utilityService.addQueryParam(this.uriRequestStudent, parameters));
  }

  getNotesStudent(solicitud: String, materia: String): Observable<ResposeGeneric> {
    const parameters = { solicitud : solicitud, materia : materia};
    return this.httpClient.get<ResposeGeneric>(this.utilityService.addQueryParam(this.uriNotesRequests, parameters));
  }

  getValTestRequests(cedula: String): Observable<ResposeGeneric> {
    const parameters = { cedula : cedula };
    return this.httpClient.get<ResposeGeneric>(this.utilityService.addQueryParam(this.uriValRequestsPifle, parameters));
  }

  getTestStudent(cedula: String): Observable<ResposeGeneric> {
    const parameters = { cedula : cedula };
    return this.httpClient.get<ResposeGeneric>(this.utilityService.addQueryParam(this.uriTestStudent, parameters));
  }

  declineRequest(declineRequest: DeclineAssigment): Observable<ResposeGeneric> {
    return this.httpClient.post<ResposeGeneric>(this.uriDeclineRequest, declineRequest);
  }

  declineTests(declineRequest: DeclineAssigment): Observable<ResposeGeneric> {
    return this.httpClient.post<ResposeGeneric>(this.uriDeclineTests, declineRequest);
  }

  getStateRequests(cedula: String, tipo: String): Observable<ResposeGeneric> {
    const parameters = { cedula : cedula, tipo : tipo};
    return this.httpClient.get<ResposeGeneric>(this.utilityService.addQueryParam(this.uriStateRequests, parameters));
  }

  getStateTesting(cedula: String, tipo: String): Observable<ResposeGeneric> {
    const parameters = { cedula : cedula, tipo : tipo};
    return this.httpClient.get<ResposeGeneric>(this.utilityService.addQueryParam(this.uriStateTesting, parameters));
  }

  getTestRequest(filter: FilterRequestTest): Observable<ResposeGeneric>  {
    return this.httpClient.get<ResposeGeneric>(this.utilityService.addQueryParam(this.uriRequestTest, filter));

  }

  getRequestRecognition(requestFilter: FilterRequestRecon ): Observable<ResposeGeneric> {
    return this.httpClient.get<ResposeGeneric>(this.utilityService.addQueryParam(this.uriRequestRecog, requestFilter));
  }

}
